import React from 'react';
import {Button, UncontrolledAlert} from 'reactstrap';
import PropTypes from 'prop-types';
import Utils from "../../../common/Utils";
import TTLProxy from "../../../common/TTLAsyncProxy";
import {UsersEndpoints} from "../../../common/ProxyEndpoints";
import SmartDialog from "../../SmartDialog/SmartDialog";
import {ErrorDisplay} from "../../../views/Register/RegisterBase";
import MDProgress from 'react-md-progress-bar';
import TokenInput from "../../TokenInput/TokenInput";
import HTML from '../../../common/HtmlHelpers';

class ActivateEmailDialog extends  React.Component{

    static propTypes = {
        onActivated: PropTypes.func,
    };

    constructor(props){
        super(props);

        this.state = ActivateEmailDialog.getInitialState();
        this.proxy = TTLProxy.getInstance();
    }

    static getInitialState(){

        return {
            isBusy: false,
            warningMessage: null,
            errorMessage: null,
            confirmCode: null,
            isTokenValid: false
        };

    }

    async dispatch(){

        this.setState({
            warningMessage: null,
            isBusy: true
        });

        try {

            const res = await this.proxy.processRequest(UsersEndpoints.beginActivateMyEmail());

            this.setState({
                warningMessage: null
            });

        }
        catch (e) {

            this.setState({
                warningMessage: Utils.getResponseError(e),
                errorMessage: null
            });

        }
        finally {

            this.setState({
                isBusy: false
            });

        }

    }

    completeActivation(){

        const props = this.props;

        this.setState({
            isBusy: true,
            errorMessage: null,
            warningMessage: null
        });

        const value = this.state.confirmCode || "";

        if(!value){

            this.setState({
               errorMessage: "Please enter confirmation code"
            });

            return;

        }

        const proxy = this.proxy;

        return proxy.processRequest(UsersEndpoints.completeActivateMyEmail(value)).then(response => {

            this.setState({
                isBusy: false
            });

            //  on activated
            if(props.onActivated){
                props.onActivated();
            }

            //
            HTML.toastSuccess('Email activated successfully');

            //
            this._dlg.hide();

        }).catch(err => {

            this.setState({
                errorMessage: Utils.getResponseError(err),
                isBusy: false
            });

        });
    }

    show(){

        this.setState(ActivateEmailDialog.getInitialState(),async () => {

            //  show dialog
            this._dlg.show();

            //  dispatch
            if(!this.__dispatched){
                await this.dispatch();
                this.__dispatched = true;
            }

        });

    }

    render(){

        const { isTokenValid } = this.state;

        return <SmartDialog ref={r => this._dlg = r} title={"Activate Email"}>
            <p>You will be sent a confirmation code to your email. If you haven't received it yet, click <a href="#" className="btn-link" onClick={async evt => {

                //
                evt.preventDefault();

                //  dispatch
                await this.dispatch();

            }}>here</a> to resend</p>

            <div>
                <TokenInput placeholder={"Enter activation code here"}
                            className="form-input form-control"
                            padding={8}
                            onChange={({ value , isValid }) => {

                    this.setState({
                        confirmCode: value,
                        isTokenValid: isValid
                    });

                }}/>

                {this.state.errorMessage && <ErrorDisplay error={this.state.errorMessage}/>}
            </div>
            {this.state.warningMessage && <UncontrolledAlert color="warning">{this.state.warningMessage}</UncontrolledAlert>}
            <hr/>
            {this.state.isBusy && <MDProgress show={true} overlay={true}/>}
            <Button color={"green"} disabled={!isTokenValid} block onClick={() => {
                this.completeActivation();
            }}>Confirm Email <i className="fa fa-check"/></Button>
        </SmartDialog>;
    }
}

class View extends React.Component{

    constructor(props){
        super(props);

        this.specialCommands  = [
            {
                action: "activate_email",
                render: () => {

                    return <div>

                        <Button size={"sm"} color={"primary"} outline={true} style={{borderRadius: 5}} onClick={() => {

                            //  show dialog
                            this._activateDlg.show();

                        }}><i className="fa fa-mail-forward"/> Activate Now</Button>

                        <ActivateEmailDialog ref={r => this._activateDlg = r}
                                             onActivated={props.onRefresh}/>

                    </div>

                }
            }

        ];
    }

    render(){

        const props = this.props;
        const notif = props.notification;
        const meta = notif.metadata;
        const specialCmd = this.specialCommands.find(x => x.action === meta.Action);

        return <div style={props.style}>
            <div className="clearfix">
                <div className="pull-left">
                    <h5>{notif.title}</h5>
                </div>
            </div>
            <p>{meta.Message}</p>

            <div className="clearfix">

                {specialCmd && <div className="pull-left">
                    {specialCmd.render()}
                </div>}

                <div className="pull-right">
                    <label>{Utils.formatDateStandard(notif.date_created)}</label>
                </div>

            </div>

        </div>;
    }



}

View.propTypes = {
    notification: PropTypes.object,
    onRefresh: PropTypes.func,
    style: PropTypes.object
};

export default View;


// WEBPACK FOOTER //
// ./src/components/UserNotifications/Templates/Other.js